import { render, staticRenderFns } from "./socios-table.vue?vue&type=template&id=e692a85e"
import script from "./socios-table.vue?vue&type=script&lang=js"
export * from "./socios-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports